if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    //header scroll
	let scrollpos = window.scrollY
	const full_header = document.querySelector('.header');

    window.addEventListener('scroll', function() { 
		scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up")
		}
		//console.log(scrollpos)
	});

    //form headlines
	// const form_headlines = document.querySelectorAll('.form-headline');
	// for (let i = 0; i < form_headlines.length; i++) {
	// 	let headline_form_copy = form_headlines[i].textContent;
	// 	form_headlines[i].outerHTML = '<div class="homepage-club__headline-section"><div class="homepage-club__headline-holder"><div class="homepage-club__headline hide-object">'+headline_form_copy+'</div></div></div>';  
	// }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //tabs sections
	const tabLinks = document.querySelectorAll('.js-tabs-menu a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].classList.remove('active');
			}
			this.classList.add('active');
			return false;
		}
	}

    const intro_content = document.querySelector('.top-content-home__headline');

	if(intro_content){
		document.getElementsByClassName('top-content-home__headline')[0].classList.add('appear');
	}

    const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();

    // hide, show, or toggle
    const show = function (elem) {
        let getHeight = function () {
            elem.style.display = 'block';
            let height = elem.scrollHeight + 'px';
            elem.style.display = '';
            return height;
        };
        let height = getHeight(); // get element height
        elem.classList.add('appear');
        elem.style.height = height; // update the max-height
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);
    };
    const hide = function (elem) {
        elem.style.height = elem.scrollHeight + 'px';
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 1);
        window.setTimeout(function () {
            elem.classList.remove('appear');
        }, 350);
    };
    const toggle = function (elem) {
        if (elem.classList.contains('appear')) {
            hide(elem);
            return;
        } else {
            show(elem);
        }
    };
    //toggle more details
    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('toggle-btn-js')) return;
        event.preventDefault();

        let content = document.querySelector(event.target.hash);
        let allcontent = document.querySelectorAll('.toggle-content');

        if (event.target.classList.contains('active')) {
            event.target.classList.remove('active');
            //hide(content);
        } else {
            event.target.classList.add('active');
            //show(content);
        }

        // var els = document.querySelectorAll('.toggle-btn-js');
        // [].forEach.call(els, function(el, i, els) {
        //     el.addEventListener('click', function() {
        //         [].forEach.call(els, function(el) {
        //             if(el !== this) {
        //                 //hide(content);
                        
        //             } else {
        //                 show(content);
        //             }
        //         }, this);
        //     });
        // });

        if (!content) return;
        toggle(content);
    }, false);

    $('.sym-slides').slick({
        accessibility: false
    });

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
    const menu = document.querySelector('.header__full-navigation');
    const isMenuVisible = menu && menu.classList.contains('expanded');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}


document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();


    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.header__full-navigation');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});